import { render, staticRenderFns } from "./miniapp-tickets.vue?vue&type=template&id=98b41944&scoped=true"
import script from "./miniapp-tickets.vue?vue&type=script&lang=js"
export * from "./miniapp-tickets.vue?vue&type=script&lang=js"
import style0 from "./miniapp-tickets.vue?vue&type=style&index=0&id=98b41944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b41944",
  null
  
)

export default component.exports